import React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { IDataRequest } from '@vivli/features/data-requests/infrastructure/interface';
import { PublishingContentComponent } from './publishing-content.component';
import { ICitation } from '@vivli/shared/features/citations/infrastructure/interface';

interface PublishingContentFormComponentProps {
    dataRequest: IDataRequest;
    isConfigMode: boolean;
    citations?: ICitation[];
}

export const PublishingContentFormComponent = ({ dataRequest, isConfigMode }: PublishingContentFormComponentProps) => {
    //this wrapper is just to initialize and pass in the
    // useFieldArray arrayNames and fields
    // to the PublishingContentComponent, where they're used in the
    // RequestedStudy and PublicDisclosures sections by the Form (but ignored in Preview views
    // of the page)
    const requestedStudiesArrayName = 'requestedStudies';
    const disclosuresArrayName = 'publishing.publishingRules.citationPublishingRules';

    const formApi = useFormContext();

    const {
        fields: fieldsListStudies,
        append,
        remove,
    } = useFieldArray({
        name: requestedStudiesArrayName,
        keyName: 'idRequestedStudies',
        control: formApi?.control,
    });

    const { fields: fieldsListDisclosures } = useFieldArray({
        name: disclosuresArrayName,
        keyName: 'idDisclosures',
        control: formApi?.control,
    });

    return (
        <PublishingContentComponent
            dataRequest={dataRequest}
            isConfigMode={isConfigMode}
            arrayNameStudies={requestedStudiesArrayName}
            fieldsStudies={fieldsListStudies}
            arrayNameDisclosures={disclosuresArrayName}
            fieldsDisclosures={fieldsListDisclosures}
        />
    );
};
